const nextRoutes = require('next-routes');
const routes = module.exports = nextRoutes();

routes.add({
	name: '/',
	pattern: '/',
	page: 'index',
});

routes.add({
	name: '/signup',
	pattern: '/signup',
	page: 'signup',
});

routes.add({
	name: '/subscribe',
	pattern: '/subscribe',
	page: 'subscribe',
})

routes.add({
	name: '/signin',
	pattern: '/signin',
	page: 'signin',
});

routes.add({
	name: '/editor',
	pattern: '/editor',
	page: 'editor',
});

routes.add({
	name: '/account',
	pattern: '/account',
	page: 'account',
});

routes.add({
	name: '/test',
	pattern: '/test',
	page: 'test',
});

routes.add({
	name: '/files',
	pattern: '/files',
	page: 'files',
});

routes.add({
	name: '/integrations',
	pattern: '/integrations/:slug',
	page: 'integrations'
})


// WEBPACK FOOTER //
// ./routes.js